module.exports = __webpack_public_path__ + "img/sld_abt_disable.4bfa1e1c.svg";